import { type FC } from "react";
import { Stack } from "@mui/material";
import { FilterProvider } from "@/partner/shared/components/Filter";
import { UsersFilter } from "./UsersFilter";
import { UsersList } from "./UsersList";
import { UserDialog } from "./UserDialog";
import { useSearchParams } from "react-router-dom";
import qs from "qs";

export const Users: FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const { tab, id: userId } = qs.parse(searchParams.toString(), {
    ignoreQueryPrefix: true,
  }) as { tab?: string; id?: string };

  const handleClickUser = (id: string) => {
    searchParams.set("tab", "details");
    searchParams.set("id", id);
    setSearchParams(searchParams);
  };

  const handleCloseUserDialog = () => {
    searchParams.delete("tab");
    searchParams.delete("id");
    setSearchParams(searchParams);
  };

  return (
    <FilterProvider>
      <Stack spacing={1}>
        <UsersFilter />
        <UsersList onClickItem={handleClickUser} />
      </Stack>

      <UserDialog
        open={tab === "details"}
        userId={userId ?? null}
        onClose={handleCloseUserDialog}
      />
    </FilterProvider>
  );
};
